/**
 * La legenda dei grafici che, al passaggio del mouse su una voce, evidenzia la
 * sua serie e attenua le altre. Avvolge `ChartLegendContent` di shadcn senza
 * cambiarlo e non passa da React: Recharts rianima a ogni render, quindi la
 * voce sotto il mouse si segna sul DOM (`data-evidenziata` sul grafico, la
 * classe `evidenziata` sulla serie) e il resto lo fa il CSS in `index.css`.
 *
 * Ogni serie porta `className={classeSerie(chiave)}`, con la chiave del suo
 * `dataKey`.
 */

import type { ComponentProps } from 'react';
import { ChartLegendContent } from '@/components/ui/chart';
import { classeSerie } from '../valutazioni/graficiConfronto.js';

function evidenzia(da: Element, chiave: string | undefined) {
  const grafico = da.closest('[data-slot="chart"]');
  if (!grafico) return;
  for (const el of grafico.querySelectorAll('.evidenziata')) el.classList.remove('evidenziata');
  if (chiave === undefined) {
    grafico.removeAttribute('data-evidenziata');
    return;
  }
  grafico.setAttribute('data-evidenziata', '');
  for (const el of grafico.querySelectorAll(`.${CSS.escape(classeSerie(chiave))}`)) {
    el.classList.add('evidenziata');
  }
}

export function LegendaEvidenziabile(props: ComponentProps<typeof ChartLegendContent>) {
  // Le voci nell'ordine in cui ChartLegendContent le disegna.
  const voci = (props.payload ?? []).filter((v) => v.type !== 'none');
  return (
    <div
      className="legenda-evidenziabile"
      onMouseOver={(e) => {
        const lista = e.currentTarget.firstElementChild;
        const figli = lista ? [...lista.children] : [];
        const i = figli.findIndex((f) => f.contains(e.target as Node));
        const chiave = voci[i]?.dataKey;
        evidenzia(e.currentTarget, chiave === undefined ? undefined : String(chiave));
      }}
      onMouseLeave={(e) => evidenzia(e.currentTarget, undefined)}
    >
      <ChartLegendContent className="flex-wrap gap-x-4 gap-y-1" {...props} />
    </div>
  );
}
